import { FunctionComponent, MouseEvent } from "react";

import { ILink, IPoint } from "../interfaces";
import { LinkChangeType, LinkPassableProps, PicassoEditorProps, SelectablePoint } from "../types";

export type LinkComponentProps = {
    readonly index: number;
    readonly link: ILink;
    readonly isSelected: boolean;
    readonly isAnyPointSelected: boolean;
    readonly renderLink: (linkName: string, passableProps: LinkPassableProps) => JSX.Element;
    readonly onLinkChange?: (changedLinkIndex: number, newPoints: readonly IPoint[]) => void;
    readonly updateLinks: (changedLinks: readonly LinkChangeType[]) => void;
    readonly selectLink: (link: ILink, reselect: boolean) => void;
    readonly unselectLink: (linkIndex: number) => void;
    readonly selectPoint: (selectedPoint: SelectablePoint | null) => void;
} & PicassoEditorProps;

export const LinkComponent: FunctionComponent<LinkComponentProps> = ({ index, isSelected, link, isAnyPointSelected, picassoInstanceKey, renderLink, updateLinks, selectLink, unselectLink, selectPoint, onLinkChange }) => {
    const handleLinkClick = (e: MouseEvent) => {
        if (e.ctrlKey) {
            if (isSelected)
                unselectLink(index);
            else
                selectLink(link, false);
        } else
            selectLink(link, true);
    };

    const handleUpdateLinksPoints = (newPoints: readonly IPoint[]) => {
        if (onLinkChange)
            onLinkChange(index, newPoints);

        updateLinks([{ index, newPoints }]);
    };

    const handlePointSelection = (pointIndex: number, originCursorCoordinates: IPoint, lastPosition: IPoint) => {
        selectPoint({ pointIndex, originCursorCoordinates, linkIndex: index, lastPosition });
    };

    const concreteLink = renderLink(link.name, { isSelected, link, isAnyPointSelected, picassoInstanceKey, onLinkClick: handleLinkClick, updatePoints: handleUpdateLinksPoints, selectPoint: handlePointSelection });

    return (concreteLink);
};
